export default __webpack_public_path__ + "static/media/stars_background_spaced.34128a87.png";